// A quirk of the Splide JS carousel: if we want to override their arrow SVG
// with our own, we need to provide it as a string and set it in the config
// for each carousel. It then takes care of inverting the arrow for 'prev',
// so this path corresponds to a right-facing 'next' arrow.

export const rowArrowPath = 'M31.8 21.9c1.1-1.5.4-3-.6-4.3L14.8.9c-3-2.6-6.9 1.1-4.3 4.3.6.9 14.6 14.6 14.6 15 0 .6-13.5 14.2-14.4 15-2.6 2.6 1.5 6.4 4.1 4.1 5.9-5.6 11.5-11.4 17-17.4z'
